import { api } from '#client/lib/api';
import { ENDPOINT } from '#client/lib/endpoints';

/** Makes a template the default, which demotes whichever one was. */
export function makeDefaultTemplate(templateId: number): Promise<unknown> {
  return api.post(ENDPOINT.printTemplateDefault(templateId), {});
}
